<template>
  <div>
    <div class="column">
      <div class="custom_table_filters column">
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterStartDate"
            name="uniquename"
            :placeholder="$t('msg.start_date')"
          ></datepicker>
        </div>
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterEndDate"
            name="uniquename"
            :placeholder="$t('msg.end_date')"
          ></datepicker>
        </div>

        <div class="component_normal_input_block dis_inb main_white_bg">
          <select v-model="statusFilter">
            <option value="all">{{ $tc("msg.all", 1) }}</option>
            <option value="cancelled">{{ $tc("msg.cancelled", 1) }}</option>
            <option value="done">{{ $tc("msg.status_done") }}</option>
            <option value="expired">{{ $tc("msg.status_expired") }}</option>
            <option value="failed">{{ $tc("msg.failed", 1) }}</option>
            <option value="new">{{ $tc("msg.new") }}</option>
            <option value="waiting">{{ $tc("msg.waiting", 1) }}</option>
          </select>
        </div>

        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="applyFilter()"
        >
          {{ $tc("msg.apply_filter", 1) }}
        </button>
        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="clearFilter()"
        >
          {{ $tc("msg.clear_filter", 1) }}
        </button>
      </div>
    </div>
    <div class="column tal_r">
      <input
        v-model="searchBox"
        class="custom_input_white"
        :placeholder="$t('msg.global_search')"
      />
    </div>
    <div class="column">
      <vue-good-table
        :columns="columns"
        :rows="tableRows"
        :select-options="{ enabled: false }"
        :search-options="{
          enabled: true,
          searchFn: customSearch,
          externalQuery: searchBox,
        }"
        ref="historytable"
        :line-numbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'createdAt', type: 'desc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: '5',
          position: 'down',
          perPageDropdown: [10, 15, 20],
          dropdownAllowAll: false,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      >
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label == 'address'">{{
            $t("msg.userid")
          }}</span>
          <span v-if="props.column.label == 'createdAt'">{{
            $t("msg.createdAt")
          }}</span>
          <span v-if="props.column.label == 'updatedAt'">{{
            $t("msg.updatedAt")
          }}</span>
          <span v-if="props.column.label == 'amount'">{{
            $t("msg.amount")
          }}</span>
          <span v-if="props.column.label == 'status'">{{
            $t("msg.status")
          }}</span>
          <span v-if="props.column.label == 'action'">{{
            $t("msg.action")
          }}</span>
        </template>

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.label == 'id'">
            <a
              v-if="props.formattedRow[props.column.field]"
              :title="$t('msg.details')"
              :href="`https://bscscan.com/tx/${
                props.formattedRow[props.column.field]
              }`"
              target="blank_"
              >{{ ajustTokenID(props.formattedRow[props.column.field]) }}</a
            >
          </span>
          <span v-if="props.column.field == 'createdAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'address'">
            
            <span v-if="props.formattedRow.action == 'send'">{{ props.formattedRow[props.column.field] }}</span>
            <span v-if="props.formattedRow.action == 'receive'">{{ props.formattedRow.memberUID }}</span>

          </span>
          <span v-if="props.column.field == 'updatedAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'amount'">
            <span v-if="props.formattedRow[props.column.field] > 0">
              <span v-if="props.formattedRow[props.column.field]">{{
                props.formattedRow[props.column.field].toFixed(6)
              }}</span>
              {{ symbAjust(props.row.currency.symbol) }}
            </span>
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'status'">{{
            $t("msg.status_" + props.formattedRow[props.column.field])
          }}</span>
          <span v-if="props.column.field == 'action'">{{
            $t("msg.internal_action_" + props.formattedRow[props.column.field])
          }}</span>
        </template>

        <div slot="emptystate">
          <p class="tac">{{ $tc("msg.no_data_found", 1) }}</p>
        </div>
      </vue-good-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
// import moment from 'moment'
import spacetime from "spacetime";

export default {
  created() {
    this.getWithdraws();
    this.getAccountsVersion();
    
  },
  mounted() {},
  data: () => ({
    internalWithdraws: "",
    searchBox: "",
    statusFilter: "all",
    filterStartDate: "",
    filterEndDate: "",
    withdraws: [],
    depositsOnPage: [],
    accountVersion: [],
    internalReceive: [],
    totalArray: [],
    tableRows: [],
    columns: [
      // {
      //   label: "id",
      //   field: "blochchainOpeation.operationEtxid",
      //   filterable: true
      // },
      {
        label: "memberUID",
        field: "memberUID",
        hidden: true,
      },
      {
        label: "address",
        field: "address",
      },
      {
        label: "createdAt",
        field: "createdAt",
      },
      {
        label: "updatedAt",
        field: "updatedAt",
      },
      {
        label: "amount",
        field: "amount",
        type: "number",
        filterable: true,
      },
      {
        label: "status",
        field: "status",
        filterable: true,
      },

      {
        label: "action",
        field: "action",
        filterable: true
      }
    ],
  }),
  components: {
    Datepicker,
  },
  methods: {

    symbAjust(el){
      if(el == 'BLU'){
        return 'BLUE'
      }else{
        return el
      }
    },


    async getWithdraws() {
      try {
        let resp = await this.$store.dispatch("getWithdraws");
        this.withdraws = resp.data;

        // this.internalWithdraws = this.sortByCreatedAt(this.withdraws);
        this.internalWithdraws = this.withdraws;

        this.filterInternalWithdraws(this.internalWithdraws);
      } catch (e) {
        console.log(e);
      }
    },

    async getAccountsVersion() {
      await this.$store
        .dispatch("getAccountsVersions")
        .then((resp) => {
          this.accountVersion = resp.data;

          this.appendArray();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    filterInternalWithdraws(withdraws) {
      let array = [];
      for (let i in withdraws) {
        if (withdraws[i].type == "internal") {
          array.push(withdraws[i]);
          withdraws[i].action = 'send';
        }
      }

      this.internalWithdraws = array;

      // this.appendArray();
    },

    sortByCreatedAt(array) {
      array.sort((a, b) => {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;

      return array;
    },

    applyFilter() {
      let startDateOnInput = this.filterStartDate;
      let endDateOnInput = this.filterEndDate;

      let date1 = new Date(startDateOnInput);
      let date2 = new Date(endDateOnInput);

      let startDate = `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10 ?   '0' +  (date1.getMonth() + 1) : date1.getMonth() + 1
      }-${ date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate() }T00:00:00.000Z`;

      let endDate = `${date2.getFullYear()}-${
        date2.getMonth() + 1 < 10 ?   '0' +  (date2.getMonth() + 1) : date2.getMonth() + 1
      }-${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()}T23:59:999Z`;

      this.filterRowByDate(startDate, endDate);
    },

    filterRowByDate(startDate, endDate) {
      this.tableRows = this.totalArray;

      this.tableRows = this.tableRows.filter((item) => {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.tableRows = this.tableRows.filter((item) => {
          return item.status == this.statusFilter;
        });
      }
    },
    clearFilter() {
      this.tableRows = this.totalArray;
      this.statusFilter != "all"
    },

    customSearch(row, col, cellValue, searchTerm) {
      let vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },

    ajustTokenID(tokenID) {
      let str = tokenID;
      let res = str.substring(0, 15);

      return res + "... [+]";
    },

    formatDate(value) {
      return spacetime(value).format("dd/MM/yyyy HH:mm:SS");
    },


    async linkVersionToWithdraw(id){
      let resp = await this.$store.dispatch('getWithdrawById', id);
      if(resp.status == 200){
        return resp;
      }else{
        console.log('error')
      }
    },

    async appendArray(){

      let moves = this.accountVersion;

      for (let i in moves) {
        if (moves[i].modifiableType == "withdraw_done" && moves[i].balance > 0) {
          let resp = await this.linkVersionToWithdraw(moves[i].modifiableId);
          resp.data.action = 'receive'
          this.internalReceive.push(resp.data)
        }
      }

      let internal = await this.internalWithdraws;
      let receive = await this.internalReceive;

      this.totalArray = receive.concat(internal);
      this.tableRows = receive.concat(internal);

      this.sortByCreatedAt(this.totalArray)

    }

  },
  computed: {},
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/Transactions/TransactionTableInternal.vue